import React from 'react';

import { faUsers } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '@mui/material';

import StrongTextField from '../components/StrongTextField';

export default {
  title: 'Utilisateurs',
  name: 'individus',
  icon: faUsers,
  resource: 'individu',
  primaryKey: 'idindividu',
  head: {
    nom: 'Nom',
    prenom: 'Prenom',
    email: 'Email',
    tel_port: 'Téléphone',
    admin: 'Admin',
  },
  list: ({ values }) => [values.nom, values.prenom, values.email, values.tel_port, values.admin],
  filter: ({ values, props }) => [
    <StrongTextField name='nom' label='Nom' values={values.nom} {...props} />,
    <StrongTextField name='prenom' label='Prenom' values={values.prenom} {...props} />,
    <StrongTextField name='email' label='Email' values={values.email} {...props} />,
    <StrongTextField name='admin' label='Admin' values={values.admin} {...props} />,
  ],
  edit: ({ values, props }) => [
    <TextField {...props} fullWidth name='civilite' label='Civilite' value={values.civilite} />,
    <TextField {...props} fullWidth name='nom' label='Nom' value={values.nom} />,
    <TextField {...props} fullWidth name='nom_jeune_fille' label='Nom de jeune fille' value={values.nom_jeune_fille} />,
    <TextField {...props} fullWidth name='prenom' label='Prénom' value={values.prenom} />,
    <TextField {...props} fullWidth name='adresse' label='Adresse' value={values.adresse} />,
    <TextField {...props} fullWidth name='cp' label='Code postal' value={values.cp} />,
    <TextField {...props} fullWidth name='ville' label='Ville' value={values.ville} />,
    <TextField {...props} fullWidth name='email' label='Email' value={values.email} />,
    <TextField {...props} fullWidth name='tel_port' label='Téléphone (portable)' value={values.tel_port} />,
    <TextField {...props} fullWidth name='tel_dom' label='Téléphone (domicile)' value={values.tel_dom} />,
    <TextField {...props} fullWidth name='admin' label='Admin' value={values.admin} />,
  ],
  add: true,
  show: true,
  popup: true,
  remove: true,
};
